export var ADD_PAYMENT_METHOD = 'Add Payment Method'; // Checkout Header message
export var EDIT_PAYMENT_METHOD = 'Edit Payment Method'; // Checkout Header message
export var CANCEL_ANYTIME = '(No worries! Cancel anytime.)'; // Checkout subheader message

export var RESUBSCRIBE_REVIEW = '1 click resubscribe review'; // rio view name

export var DEFAULT_LAYOUT_TESTID = 'default-layout';
export var PLAN_SELECTION_LAYOUT_TESTID = 'plan-selection-layout';
export var CART_CHECKOUT_TESTID = 'CART_CHECKOUT';
export var MULTI_MONTH_RESUB_LAYOUT_TESTID = 'multi-month-layout';
export var FOOTER_PRICING_WRAPPER_TESTID = 'footer-pricing-wrapper';
export var TAX_WRAPPER = 'tax-wrapper';
export var FULL_PM_VIEW_CLASS = 'fullPMView';
export var PAYMENT_LEFT_CLASS = 'left';
export var PAYMENT_RIGHT_CLASS = 'right';
export var SALE_BANNER_ID = 'sale_banner';
export var VPN_DETECTED_BANNER_ID = 'vpn_detected_banner';

// PLAN SELECTION SPECIFIC -- packages is currently expected to be [BUNDLE, CHEGG_STUDY]
export var CSP_PACKAGE_INDEX = 0;
export var CS_PACKAGE_INDEX = 1;
export var ONE_CLICK_ERROR_LOCATION = 'One Click Checkout';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/constants.js
// module id = 232
// module chunks = 11